import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PermissionsTable } from './components';
import { Wrapper } from './styles';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const UserPermissions: FC = () => {
  const { t } = useTranslation();
  const { isExpiredSoon, isBlocked } = useSubscription();

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <h1>{t('user_permissions')}</h1>
      <PermissionsTable />
    </Wrapper>
  );
};

export default UserPermissions;
